export default "__VITE_ASSET__CNtl5VGD__"